module.exports = __webpack_public_path__ + "static/foto_Equity-17e164865f1d75416cb8c1d538ee8161.jpg";